import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { dentistsData } from '../../mocks/dentists';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/e43269811b4a2a5e2db973f06d63ec73.jpeg"
            alt="Bighorn Family Dental building exterior"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-primary/60 via-primary/40 to-primary/60"></div>
        </div>

        <div className="relative z-10 text-center text-white max-w-3xl mx-auto px-8">
          <h1 className="font-serif text-5xl mb-5">About Bighorn Family Dental</h1>
          <div className="flex items-center justify-center gap-5 text-base">
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-2-line"></i>
              <span>825 Simms St, Golden, CO 80401</span>
            </div>
            <div className="w-1 h-1 bg-white/50 rounded-full"></div>
            <a href="tel:2296519254" className="flex items-center gap-2 hover:text-white/80 transition-colors cursor-pointer">
              <i className="ri-phone-line"></i>
              <span>(229) 651-9254</span>
            </a>
          </div>
        </div>
      </section>

      {/* Clinic Story */}
      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 gap-16 items-center">
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/079028b64cd77a059ecbc56c1fbe84ea.jpeg"
                alt="Dental consultation - dentist discussing treatment plan with patient"
                className="w-full h-[520px] object-cover object-center rounded-2xl shadow-lg"
              />
            </div>

            <div>
              <div className="text-sm uppercase tracking-widest text-accent font-semibold mb-3">Our Story</div>
              <h2 className="font-serif text-4xl text-navy mb-6 leading-tight">
                Trusted Dental Care for Golden Families
              </h2>
              <div className="space-y-4 text-navy/70 leading-relaxed mb-8">
                <p>
                  At Bighorn Family Dental, we believe that exceptional dental care goes beyond treating teeth—it is about building lasting relationships with our patients and their families.
                </p>
                <p>
                  For over 18 years, we have been proud to serve the Golden, Colorado community with comprehensive, compassionate dental services in a modern, welcoming environment.
                </p>
                <p>
                  We understand that every patient is unique, which is why we take the time to listen to your concerns and create personalized treatment plans.
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center p-5 bg-sand rounded-xl">
                  <div className="font-serif text-3xl text-primary mb-1">18+</div>
                  <div className="text-xs text-navy/60">Years Experience</div>
                </div>
                <div className="text-center p-5 bg-sand rounded-xl">
                  <div className="font-serif text-3xl text-primary mb-1">5000+</div>
                  <div className="text-xs text-navy/60">Happy Patients</div>
                </div>
                <div className="text-center p-5 bg-sand rounded-xl">
                  <div className="font-serif text-3xl text-primary mb-1">4.9★</div>
                  <div className="text-xs text-navy/60">Patient Rating</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Our Team */}
      <section className="py-20 px-8 bg-sand/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="text-sm uppercase tracking-widest text-accent font-semibold mb-3">Our Expert Team</div>
            <h2 className="font-serif text-4xl text-navy mb-3">Meet Our Dentists</h2>
            <p className="text-navy/60 max-w-xl mx-auto">
              Experienced professionals dedicated to providing you with the highest quality care
            </p>
          </div>

          <div className="mb-16">
            <img
              src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/4bbd0af13db54da32d944d9f98bd0a6e.jpeg"
              alt="Bighorn Family Dental team photo"
              className="w-full h-[500px] object-cover object-center rounded-2xl shadow-lg"
            />
          </div>

          <div className="grid grid-cols-4 gap-6">
            {dentistsData.map((dentist) => (
              <div key={dentist.id} className="group bg-white rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300">
                <div className="aspect-[4/5] overflow-hidden bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center">
                  {dentist.id === 1 ? (
                    <img
                      src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/7acec5418ff10f402a921cbd134403d2.jpeg"
                      alt={dentist.name}
                      className="w-full h-full object-cover object-top"
                    />
                  ) : dentist.id === 2 ? (
                    <img
                      src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/6ff03944ef24e56ad83ef4309582cde9.jpeg"
                      alt={dentist.name}
                      className="w-full h-full object-cover object-top"
                    />
                  ) : dentist.id === 3 ? (
                    <img
                      src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/7a05da19f666210a8051a2d799bf2011.jpeg"
                      alt={dentist.name}
                      className="w-full h-full object-cover object-top"
                    />
                  ) : dentist.id === 4 ? (
                    <img
                      src="https://static.readdy.ai/image/f18e67251944660e2a4a540d67ead456/2e06a241f4fa845f403ee3cb724337c4.jpeg"
                      alt={dentist.name}
                      className="w-full h-full object-cover object-top"
                    />
                  ) : (
                    <i className="ri-user-line text-7xl text-primary/30"></i>
                  )}
                </div>
                <div className="p-5 text-center">
                  <h3 className="font-serif text-lg text-navy mb-0.5">{dentist.name}</h3>
                  <div className="text-sm text-accent font-medium mb-1">{dentist.credentials}</div>
                  <div className="text-xs text-navy/50 mb-2">{dentist.specialization}</div>
                  <div className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs rounded-full font-medium">
                    {dentist.experience} Years
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="text-sm uppercase tracking-widest text-accent font-semibold mb-3">Our Values</div>
            <h2 className="font-serif text-4xl text-navy">Why Families Choose Us</h2>
          </div>

          <div className="grid grid-cols-3 gap-8">
            <div className="bg-sand/50 rounded-xl p-8 hover:shadow-md transition-all">
              <div className="w-14 h-14 flex items-center justify-center bg-primary/10 rounded-xl mb-5">
                <i className="ri-heart-2-line text-2xl text-primary"></i>
              </div>
              <h3 className="font-serif text-xl text-navy mb-3">Patient-Centered Care</h3>
              <p className="text-navy/60 leading-relaxed">
                Your comfort and well-being are our top priorities. We ensure you feel confident throughout your visit.
              </p>
            </div>

            <div className="bg-sand/50 rounded-xl p-8 hover:shadow-md transition-all">
              <div className="w-14 h-14 flex items-center justify-center bg-primary/10 rounded-xl mb-5">
                <i className="ri-microscope-line text-2xl text-primary"></i>
              </div>
              <h3 className="font-serif text-xl text-navy mb-3">Modern Technology</h3>
              <p className="text-navy/60 leading-relaxed">
                We invest in the latest dental technology for accurate diagnoses and effective treatments.
              </p>
            </div>

            <div className="bg-sand/50 rounded-xl p-8 hover:shadow-md transition-all">
              <div className="w-14 h-14 flex items-center justify-center bg-primary/10 rounded-xl mb-5">
                <i className="ri-calendar-check-line text-2xl text-primary"></i>
              </div>
              <h3 className="font-serif text-xl text-navy mb-3">Flexible Scheduling</h3>
              <p className="text-navy/60 leading-relaxed">
                Convenient appointment times including early mornings, evenings, and Saturdays.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-8 bg-primary">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="font-serif text-4xl mb-5">Join Our Dental Family</h2>
          <p className="text-lg text-white/80 mb-8">
            Experience the difference that personalized, compassionate care can make
          </p>
          <div className="flex items-center justify-center gap-4">
            <a
              href="tel:2296519254"
              className="px-8 py-4 bg-accent text-white rounded-full font-medium hover:bg-accent-dark transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Us Today
            </a>
            <a
              href="mailto:info@bfdental.org"
              className="px-8 py-4 bg-white/10 border-2 border-white text-white rounded-full font-medium hover:bg-white hover:text-primary transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              Email Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
